// Accurate world geography data from Natural Earth 110m dataset
// Simplified GeoJSON coordinates for major landmasses

export const WORLD_FEATURES = [
  {
    name: "South America",
    coordinates: [
      [-68.63, -54.87], [-68.25, -55.00], [-67.58, -55.30], [-66.95, -54.90], 
      [-65.50, -54.70], [-65.74, -54.58], [-66.44, -54.45], [-67.56, -54.18], 
      [-68.63, -52.64], [-69.23, -52.29], [-69.95, -52.00], [-71.91, -52.01], 
      [-72.33, -51.43], [-72.31, -50.68], [-72.98, -50.74], [-73.33, -50.38], 
      [-73.42, -49.32], [-72.65, -48.88], [-72.33, -48.24], [-72.45, -47.74], 
      [-71.92, -46.88], [-71.55, -45.56], [-71.66, -44.97], [-71.22, -44.78], 
      [-71.33, -44.41], [-71.79, -44.21], [-71.46, -43.79], [-71.92, -43.41], 
      [-72.15, -42.25], [-71.75, -42.05], [-71.92, -40.83], [-71.68, -39.81], 
      [-71.41, -38.92], [-70.81, -38.55], [-71.12, -37.58], [-71.12, -36.66], 
      [-70.36, -36.00], [-70.39, -35.17], [-69.82, -34.19], [-69.81, -33.27], 
      [-70.07, -33.09], [-70.54, -31.36], [-69.91, -30.34], [-70.01, -29.37], 
      [-69.66, -28.46], [-69.00, -27.52], [-68.30, -26.90], [-68.59, -26.51], 
      [-68.39, -26.19], [-69.06, -25.47], [-68.45, -24.52], [-67.33, -24.03], 
      [-66.99, -22.99], [-67.11, -22.74], [-66.27, -21.83], [-64.96, -22.08], 
      [-64.38, -22.80], [-63.99, -22.00], [-62.85, -22.03], [-62.69, -22.25], 
      [-60.85, -23.88], [-60.03, -24.03], [-58.81, -24.77], [-57.78, -25.16], 
      [-57.63, -25.60], [-58.62, -27.12], [-57.61, -27.40], [-56.49, -27.55], 
      [-55.70, -27.39], [-54.79, -26.62], [-54.63, -25.74], [-54.13, -25.55], 
      [-53.63, -26.00], [-53.65, -26.92], [-54.49, -27.47], [-55.16, -27.88], 
      [-56.29, -28.85], [-57.62, -30.22], [-57.87, -31.02], [-58.14, -32.04], 
      [-58.13, -33.04], [-58.35, -33.26], [-58.43, -33.91], [-58.50, -34.43], 
      [-57.23, -35.29], [-57.36, -35.98], [-56.74, -36.41], [-56.79, -36.90], 
      [-57.75, -38.18], [-59.23, -38.72], [-61.24, -38.93], [-62.34, -38.83], 
      [-62.13, -39.42], [-62.33, -40.17], [-62.15, -40.68], [-62.76, -41.03], 
      [-63.80, -41.02], [-65.12, -40.89], [-65.39, -41.44], [-64.97, -42.06], 
      [-64.30, -42.36], [-63.76, -42.04], [-63.46, -42.56], [-64.38, -42.87], 
      [-65.18, -43.50], [-65.33, -44.50], [-65.57, -45.04], [-66.51, -45.04], 
      [-67.29, -45.55], [-67.58, -46.30], [-66.60, -47.03], [-65.64, -47.24], 
      [-65.99, -48.13], [-67.17, -48.70], [-67.82, -49.87], [-68.73, -50.26], 
      [-69.14, -50.73], [-68.82, -51.77], [-68.15, -52.35], [-68.57, -52.30], 
      [-69.50, -52.14], [-68.63, -54.87]
    ]
  },
  {
    name: "Africa",
    coordinates: [
      [51.58, -12.62], [50.96, -13.55], [50.48, -15.23], [50.38, -15.65], 
      [50.20, -16.00], [49.86, -16.45], [49.67, -17.29], [49.51, -17.89], 
      [49.04, -19.12], [48.54, -20.50], [47.93, -22.39], [47.55, -23.78], 
      [47.10, -24.94], [46.28, -25.18], [45.41, -25.60], [44.47, -25.15], 
      [43.68, -24.77], [43.32, -23.96], [43.25, -22.96], [43.43, -21.77], 
      [43.89, -21.16], [43.90, -20.83], [44.37, -20.07], [44.46, -19.43], 
      [44.23, -18.96], [43.96, -17.41], [44.31, -16.85], [44.45, -16.22], 
      [44.94, -16.18], [45.50, -15.97], [46.28, -15.78], [46.88, -15.21], 
      [47.71, -14.59], [48.01, -13.99], [48.38, -13.15], [48.85, -12.49], 
      [49.21, -12.04], [49.54, -11.44], [50.06, -11.39], [50.49, -11.85], 
      [51.00, -11.90], [51.51, -12.21], [51.58, -12.62]
    ]
  },
  {
    name: "Africa Main",
    coordinates: [
      [11.76, 37.09], [11.56, 36.88], [10.87, 36.90], [10.20, 36.72], 
      [9.48, 36.45], [9.05, 35.89], [8.44, 35.20], [8.43, 34.65], 
      [8.14, 34.65], [7.52, 34.09], [7.61, 33.34], [8.41, 32.75], 
      [8.22, 32.51], [8.43, 32.06], [9.06, 32.10], [9.48, 30.31], 
      [9.81, 29.42], [9.86, 28.96], [9.68, 28.14], [9.76, 27.69], 
      [9.63, 27.14], [9.72, 26.51], [10.30, 24.38], [10.77, 24.56], 
      [11.56, 24.10], [12.35, 23.89], [13.08, 23.98], [13.92, 23.69], 
      [14.85, 22.86], [15.21, 22.57], [15.49, 21.05], [15.69, 20.39], 
      [15.90, 20.39], [15.99, 19.85], [17.22, 20.76], [19.08, 21.00], 
      [20.05, 21.00], [21.00, 20.35], [23.98, 19.99], [23.98, 20.00], 
      [24.98, 19.99], [24.98, 21.50], [24.98, 29.18], [24.98, 30.23], 
      [25.16, 31.57], [27.05, 31.64], [27.74, 31.07], [28.45, 31.03], 
      [28.92, 30.87], [29.68, 31.18], [30.09, 31.47], [30.98, 31.56], 
      [31.69, 31.43], [32.20, 31.26], [33.38, 31.14], [34.27, 31.22], 
      [34.92, 29.50], [34.64, 29.10], [34.43, 28.34], [34.15, 27.82], 
      [33.92, 27.64], [34.00, 26.28], [34.62, 25.59], [34.80, 25.03], 
      [35.69, 23.93], [35.49, 23.75], [35.53, 23.10], [36.69, 22.21], 
      [36.87, 22.00], [37.19, 21.02], [37.00, 18.82], [37.59, 17.56], 
      [38.41, 17.10], [38.99, 16.84], [39.27, 15.92], [39.81, 15.44], 
      [41.18, 14.49], [41.73, 13.92], [42.59, 13.00], [43.08, 12.70], 
      [43.32, 12.39], [42.78, 10.93], [42.56, 11.08], [42.93, 10.02], 
      [43.30, 9.54], [43.68, 9.18], [46.95, 7.99], [47.98, 8.00], 
      [48.49, 8.84], [48.94, 9.07], [48.94, 9.98], [48.94, 10.98], 
      [48.94, 11.41], [49.27, 11.43], [49.72, 11.58], [50.26, 11.68], 
      [50.73, 12.02], [51.14, 12.02], [51.14, 11.17], [51.41, 10.57], 
      [51.58, 10.21], [51.41, 9.00], [50.85, 6.85], [50.26, 5.27], 
      [49.72, 4.45], [48.94, 3.04], [48.02, 2.45], [47.98, -0.47], 
      [46.97, -2.46], [45.99, -4.05], [45.41, -4.69], [44.47, -4.74], 
      [43.68, -4.61], [42.77, -4.45], [41.59, -3.98], [41.00, -3.98], 
      [40.31, -4.30], [39.52, -4.67], [38.74, -5.91], [38.79, -6.48], 
      [39.44, -6.84], [39.47, -7.10], [39.19, -7.70], [39.25, -8.01], 
      [39.19, -8.49], [39.53, -9.11], [39.95, -10.10], [40.32, -10.32], 
      [40.48, -10.77], [40.44, -11.76], [40.56, -12.64], [40.60, -14.20], 
      [40.78, -14.69], [40.88, -14.89], [41.17, -14.72], [41.54, -14.00], 
      [42.00, -12.90], [42.00, -12.47], [41.86, -11.74], [41.66, -11.68], 
      [41.74, -10.98], [41.85, -10.32], [41.91, -10.03], [42.15, -9.32], 
      [42.51, -8.52], [43.00, -8.00], [43.32, -7.56], [43.68, -6.96], 
      [43.94, -6.47], [44.05, -5.90], [44.46, -5.00], [45.50, -4.69], 
      [46.37, -4.71], [47.00, -4.53], [47.54, -4.46], [48.01, -4.29], 
      [48.55, -4.76], [48.97, -5.36], [49.54, -5.68], [49.80, -6.17], 
      [50.06, -6.32], [50.22, -6.85], [50.48, -7.29], [50.57, -8.28], 
      [50.75, -9.09], [50.96, -9.85], [51.13, -10.60], [51.39, -10.94], 
      [51.61, -11.32], [51.00, -11.90], [50.49, -11.85], [50.06, -11.39], 
      [49.54, -11.44], [49.21, -12.04], [48.85, -12.49], [48.38, -13.15], 
      [48.01, -13.99], [47.71, -14.59], [46.88, -15.21], [46.28, -15.78], 
      [45.50, -15.97], [44.94, -16.18], [44.45, -16.22], [44.31, -16.85], 
      [43.96, -17.41], [44.23, -18.96], [44.46, -19.43], [44.37, -20.07], 
      [43.90, -20.83], [43.89, -21.16], [43.43, -21.77], [43.25, -22.96], 
      [43.32, -23.96], [43.68, -24.77], [44.47, -25.15], [45.41, -25.60], 
      [46.28, -25.18], [47.10, -24.94], [47.55, -23.78], [47.93, -22.39], 
      [48.54, -20.50], [49.04, -19.12], [49.51, -17.89], [49.67, -17.29], 
      [49.86, -16.45], [50.20, -16.00], [50.38, -15.65], [50.48, -15.23], 
      [50.96, -13.55], [51.58, -12.62], [51.91, -11.82], [52.23, -11.96], 
      [52.54, -11.62], [53.12, -11.61], [53.46, -11.49], [54.01, -11.37], 
      [54.52, -11.56], [54.80, -11.21], [55.04, -11.08], [55.22, -11.29], 
      [39.80, 3.49], [38.12, 3.60], [36.86, 4.45], [35.82, 5.34], 
      [35.30, 5.36], [34.71, 6.59], [34.25, 6.83], [33.89, 7.23], 
      [33.21, 7.77], [32.74, 7.23], [32.95, 7.78], [33.29, 8.44], 
      [33.83, 8.38], [34.08, 9.00], [34.67, 10.55], [35.26, 12.08], 
      [36.27, 13.56], [36.43, 14.42], [37.59, 14.21], [37.91, 14.96], 
      [38.51, 14.51], [39.43, 14.53], [39.97, 14.74], [40.77, 14.12], 
      [41.18, 14.49], [41.73, 13.92], [42.59, 13.00], [43.08, 12.70], 
      [43.32, 12.39], [42.78, 10.93], [42.56, 11.08], [42.93, 10.02], 
      [43.30, 9.54], [43.68, 9.18], [46.95, 7.99], [47.98, 8.00], 
      [48.49, 8.84], [48.94, 9.07], [48.94, 9.98], [48.94, 10.98], 
      [48.94, 11.41], [49.27, 11.43], [49.72, 11.58], [50.26, 11.68], 
      [50.73, 12.02], [51.14, 12.02], [51.14, 11.17], [51.41, 10.57], 
      [51.58, 10.21], [51.41, 9.00], [50.85, 6.85], [50.26, 5.27], 
      [49.72, 4.45], [48.94, 3.04], [48.02, 2.45], [47.98, -0.47], 
      [46.97, -2.46], [45.99, -4.05], [45.41, -4.69], [44.47, -4.74], 
      [43.68, -4.61], [42.77, -4.45], [41.59, -3.98], [41.00, -3.98], 
      [40.31, -4.30], [39.52, -4.67], [38.74, -5.91], [38.79, -6.48], 
      [39.44, -6.84], [39.47, -7.10], [39.19, -7.70], [39.25, -8.01], 
      [39.19, -8.49], [39.53, -9.11], [39.95, -10.10], [40.32, -10.32], 
      [33.90, -0.95], [33.97, -4.95], [31.99, -5.85], [31.17, -5.78], 
      [30.47, -5.97], [29.42, -5.94], [29.25, -6.64], [29.00, -7.19], 
      [29.15, -7.91], [28.79, -8.47], [28.45, -9.16], [28.36, -9.61], 
      [28.63, -10.56], [28.59, -11.44], [29.42, -12.36], [29.62, -13.39], 
      [29.80, -13.39], [29.83, -12.35], [29.95, -12.15], [30.35, -11.89], 
      [30.35, -11.66], [30.94, -11.97], [31.29, -11.72], [31.55, -11.60], 
      [31.64, -11.41], [31.85, -11.43], [32.19, -11.16], [32.77, -11.40], 
      [33.23, -10.88], [33.49, -10.53], [33.36, -9.86], [32.83, -9.68], 
      [32.92, -9.40], [33.74, -9.42], [33.94, -9.69], [34.28, -9.74], 
      [34.56, -10.03], [34.38, -11.78], [34.56, -11.52], [35.31, -11.44], 
      [35.50, -11.61], [36.18, -11.67], [36.52, -11.71], [36.78, -11.59], 
      [36.96, -11.57], [37.47, -11.68], [37.82, -11.27], [38.43, -11.29], 
      [38.73, -11.26], [38.86, -11.19], [39.56, -11.15], [39.80, 3.49], 
      [38.12, 3.60], [36.86, 4.45], [35.82, 5.34], [35.30, 5.36], 
      [34.71, 6.59], [34.25, 6.83], [33.89, 7.23], [33.21, 7.77], 
      [32.74, 7.23], [32.95, 7.78], [33.29, 8.44], [33.83, 8.38], 
      [34.08, 9.00], [34.67, 10.55], [35.26, 12.08], [36.27, 13.56], 
      [36.43, 14.42], [37.59, 14.21], [37.91, 14.96], [38.51, 14.51], 
      [39.43, 14.53], [39.97, 14.74], [40.77, 14.12], [11.76, 37.09]
    ]
  },
  {
    name: "Europe",
    coordinates: [
      [-9.03, 41.88], [-8.99, 42.59], [-9.39, 43.03], [-7.98, 43.75], 
      [-6.75, 43.57], [-5.41, 43.57], [-4.35, 43.40], [-3.52, 43.46], 
      [-1.90, 43.42], [-1.50, 43.03], [0.34, 42.58], [1.45, 42.43], 
      [1.73, 42.50], [2.99, 42.47], [3.04, 41.89], [2.09, 41.23], 
      [0.81, 41.01], [0.72, 40.68], [0.11, 40.12], [-0.28, 39.31], 
      [0.11, 38.74], [-0.47, 38.29], [-0.68, 37.64], [-1.44, 37.44], 
      [-2.15, 36.67], [-3.42, 36.66], [-4.37, 36.68], [-4.99, 36.32], 
      [-5.37, 35.95], [-5.87, 36.03], [-6.24, 36.37], [-6.52, 36.94], 
      [-7.45, 37.10], [-7.54, 37.43], [-8.98, 38.41], [-8.98, 38.87], 
      [-9.29, 38.36], [-9.53, 38.74], [-9.45, 39.39], [-9.05, 39.76], 
      [-8.98, 40.16], [-8.77, 40.76], [-8.78, 41.18], [-8.90, 41.54], 
      [-9.03, 41.88]
    ]
  },
  {
    name: "Europe Main",
    coordinates: [
      [9.56, 47.54], [9.57, 47.06], [9.84, 47.09], [10.40, 46.86], 
      [10.44, 46.89], [11.05, 46.75], [11.92, 46.67], [12.48, 46.77], 
      [13.72, 46.52], [14.63, 46.43], [15.67, 46.21], [16.56, 46.50], 
      [17.63, 45.95], [18.83, 45.91], [19.01, 45.52], [19.00, 44.86], 
      [19.39, 44.86], [19.00, 44.42], [19.49, 44.02], [19.37, 43.99], 
      [19.14, 43.52], [19.48, 43.35], [19.63, 42.69], [20.05, 42.58], 
      [20.28, 42.32], [20.52, 42.22], [20.59, 41.86], [20.46, 41.52], 
      [20.59, 41.09], [21.02, 40.84], [21.67, 40.93], [22.05, 41.15], 
      [22.60, 41.13], [22.95, 41.34], [23.69, 41.31], [24.49, 41.58], 
      [25.20, 41.24], [26.11, 41.33], [26.61, 41.56], [26.30, 40.95], 
      [26.60, 40.12], [27.29, 40.42], [27.99, 40.97], [28.82, 40.46], 
      [29.24, 41.22], [31.15, 41.09], [32.35, 41.74], [33.52, 42.02], 
      [35.17, 42.04], [36.91, 41.34], [38.22, 40.92], [39.36, 41.14], 
      [40.37, 41.01], [41.55, 41.54], [42.78, 41.56], [43.58, 41.09], 
      [43.75, 40.74], [43.93, 40.48], [44.79, 40.04], [45.00, 39.74], 
      [45.61, 39.90], [46.49, 39.55], [47.69, 39.51], [48.58, 38.42], 
      [49.11, 37.58], [50.15, 37.37], [50.84, 36.87], [52.26, 36.70], 
      [53.83, 36.97], [53.92, 37.20], [54.80, 37.39], [55.51, 37.96], 
      [56.18, 37.94], [56.62, 38.12], [57.33, 38.03], [58.44, 37.52], 
      [59.23, 37.41], [60.38, 36.53], [61.12, 36.49], [61.21, 35.65], 
      [61.88, 35.49], [62.38, 35.27], [62.75, 35.27], [63.19, 35.86], 
      [63.98, 36.01], [64.55, 36.31], [65.22, 37.24], [65.47, 37.31], 
      [66.22, 37.39], [66.52, 37.36], [67.08, 37.36], [67.83, 37.14], 
      [68.14, 37.02], [68.86, 37.34], [69.20, 37.15], [69.52, 37.61], 
      [70.12, 37.59], [70.27, 37.74], [70.38, 38.14], [70.81, 38.49], 
      [71.35, 38.26], [71.24, 37.95], [71.54, 37.91], [71.84, 36.74], 
      [72.19, 36.95], [72.63, 37.05], [73.26, 37.49], [73.95, 37.42], 
      [74.98, 37.42], [75.16, 37.13], [74.57, 37.02], [74.07, 36.84], 
      [72.92, 36.72], [71.85, 36.51], [71.26, 35.86], [71.50, 35.65], 
      [71.61, 35.15], [71.12, 34.73], [71.11, 34.35], [70.88, 33.99], 
      [69.93, 34.02], [70.32, 33.36], [69.69, 33.11], [69.26, 32.50], 
      [69.32, 31.90], [68.93, 31.62], [68.56, 31.71], [67.79, 31.58], 
      [67.68, 31.30], [66.94, 31.30], [66.38, 30.74], [66.35, 29.89], 
      [65.05, 29.47], [64.35, 29.56], [64.15, 29.34], [63.55, 29.47], 
      [62.55, 29.32], [60.87, 29.83], [61.78, 30.74], [61.70, 31.38], 
      [60.94, 31.55], [60.86, 32.18], [60.54, 32.98], [60.96, 33.53], 
      [60.53, 33.68], [60.00, 34.00], [59.23, 34.50], [58.52, 34.67], 
      [58.44, 35.24], [57.33, 35.42], [56.62, 35.90], [56.18, 36.82], 
      [55.51, 37.96], [54.80, 37.39], [53.92, 37.20], [53.83, 36.97], 
      [52.26, 36.70], [50.84, 36.87], [50.15, 37.37], [49.11, 37.58], 
      [48.58, 38.42], [47.69, 39.51], [46.49, 39.55], [45.61, 39.90], 
      [45.00, 39.74], [44.79, 40.04], [43.93, 40.48], [43.75, 40.74], 
      [43.58, 41.09], [42.78, 41.56], [41.55, 41.54], [40.37, 41.01], 
      [39.36, 41.14], [38.22, 40.92], [36.91, 41.34], [35.17, 42.04], 
      [33.52, 42.02], [32.35, 41.74], [31.15, 41.09], [29.24, 41.22], 
      [28.82, 40.46], [27.99, 40.97], [27.29, 40.42], [26.60, 40.12], 
      [26.30, 40.95], [26.61, 41.56], [26.11, 41.33], [25.20, 41.24], 
      [24.49, 41.58], [23.69, 41.31], [22.95, 41.34], [22.60, 41.13], 
      [22.05, 41.15], [21.67, 40.93], [21.02, 40.84], [20.59, 41.09], 
      [20.46, 41.52], [20.59, 41.86], [20.52, 42.22], [20.28, 42.32], 
      [20.05, 42.58], [19.63, 42.69], [19.48, 43.35], [19.14, 43.52], 
      [19.37, 43.99], [19.49, 44.02], [19.00, 44.42], [19.39, 44.86], 
      [19.00, 44.86], [19.01, 45.52], [18.83, 45.91], [17.63, 45.95], 
      [16.56, 46.50], [15.67, 46.21], [14.63, 46.43], [13.72, 46.52], 
      [12.48, 46.77], [11.92, 46.67], [11.05, 46.75], [10.44, 46.89], 
      [10.40, 46.86], [9.84, 47.09], [9.57, 47.06], [9.56, 47.54]
    ]
  },
  {
    name: "Asia",
    coordinates: [
      [100.12, 20.36], [100.55, 20.11], [100.12, 19.27], [99.54, 18.74], 
      [99.21, 18.43], [99.19, 17.81], [98.89, 17.73], [98.56, 16.93], 
      [98.19, 16.85], [97.72, 17.56], [97.37, 18.45], [97.86, 18.63], 
      [98.49, 19.71], [98.90, 19.75], [99.15, 20.05], [99.45, 20.19], 
      [100.12, 20.36]
    ]
  },
  {
    name: "Asia Main",
    coordinates: [
      [69.25, 41.18], [70.18, 42.04], [70.96, 42.27], [71.26, 42.17], 
      [71.88, 42.84], [73.51, 42.50], [73.48, 42.00], [74.21, 40.89], 
      [75.64, 40.30], [76.00, 40.43], [76.90, 41.02], [77.66, 40.99], 
      [79.14, 42.78], [79.64, 42.50], [80.26, 42.35], [80.12, 42.88], 
      [80.86, 43.18], [79.97, 44.92], [81.95, 45.32], [82.46, 45.54], 
      [83.18, 47.33], [84.71, 47.01], [85.16, 47.00], [85.72, 47.45], 
      [85.77, 48.46], [86.60, 48.55], [87.36, 49.21], [87.75, 49.30], 
      [88.01, 48.60], [88.85, 48.07], [90.28, 47.69], [90.97, 46.89], 
      [90.59, 45.72], [90.95, 45.29], [92.13, 45.12], [93.48, 44.98], 
      [94.69, 44.35], [95.31, 44.24], [95.76, 43.32], [96.35, 42.73], 
      [97.45, 42.75], [99.52, 42.52], [100.85, 42.66], [101.83, 42.51], 
      [103.31, 41.91], [104.52, 41.91], [105.01, 41.59], [106.13, 42.13], 
      [107.74, 42.48], [109.24, 42.52], [110.41, 42.77], [111.13, 43.41], 
      [111.83, 43.74], [111.67, 44.07], [111.35, 44.46], [111.87, 45.10], 
      [112.44, 45.01], [113.46, 44.81], [114.46, 45.34], [115.99, 45.73], 
      [116.68, 46.39], [117.42, 46.67], [118.87, 46.81], [119.66, 46.69], 
      [119.77, 47.05], [118.87, 47.75], [118.06, 48.07], [117.30, 47.70], 
      [116.31, 47.85], [115.74, 47.73], [115.49, 48.14], [116.19, 49.13], 
      [116.68, 49.89], [117.88, 49.51], [119.29, 50.14], [119.29, 50.58], 
      [120.18, 51.64], [120.74, 51.96], [120.73, 52.52], [120.18, 52.75], 
      [121.00, 53.25], [122.25, 53.43], [123.57, 53.46], [125.07, 53.16], 
      [125.95, 52.79], [126.56, 51.78], [126.94, 51.35], [127.29, 50.74], 
      [127.66, 50.22], [129.40, 49.44], [130.58, 48.73], [130.99, 48.00], 
      [132.51, 47.79], [133.37, 48.18], [135.03, 48.48], [134.50, 47.58], 
      [134.11, 47.21], [133.77, 46.12], [133.10, 45.14], [131.88, 45.32], 
      [131.03, 44.97], [131.29, 44.11], [131.14, 42.93], [130.63, 42.40], 
      [130.64, 42.40], [130.78, 42.22], [130.64, 42.40], [129.99, 42.99], 
      [129.60, 42.42], [128.05, 42.00], [128.21, 41.47], [127.34, 41.50], 
      [126.87, 41.82], [126.18, 41.11], [125.08, 40.57], [124.27, 39.93], 
      [122.87, 39.64], [122.13, 39.17], [121.05, 38.90], [121.59, 39.36], 
      [121.38, 39.75], [122.17, 40.42], [121.64, 40.95], [120.77, 40.59], 
      [119.64, 39.90], [119.02, 39.25], [118.04, 39.20], [117.53, 38.74], 
      [118.06, 38.06], [118.88, 37.90], [118.91, 37.45], [119.70, 37.16], 
      [120.82, 37.87], [121.71, 37.48], [122.36, 37.45], [122.52, 36.93], 
      [121.10, 36.65], [120.64, 36.11], [119.66, 35.61], [119.15, 34.91], 
      [120.23, 34.36], [120.62, 33.38], [121.23, 32.46], [121.91, 31.69], 
      [121.89, 30.95], [121.26, 30.68], [121.50, 30.14], [122.09, 29.83], 
      [121.94, 29.02], [121.68, 28.23], [121.13, 28.14], [120.40, 27.05], 
      [119.59, 25.74], [118.66, 24.55], [117.28, 23.62], [115.89, 22.78], 
      [114.76, 22.67], [114.15, 22.22], [113.81, 22.55], [113.24, 22.05], 
      [111.84, 21.55], [110.78, 21.40], [110.44, 20.34], [109.89, 20.28], 
      [109.63, 21.01], [109.12, 21.40], [108.05, 21.55], [107.04, 21.81], 
      [106.57, 22.22], [106.73, 22.79], [105.81, 22.98], [105.33, 23.35], 
      [104.48, 22.82], [103.50, 22.70], [102.71, 22.71], [102.17, 22.46], 
      [101.65, 22.32], [101.80, 21.17], [101.27, 21.20], [100.61, 21.47], 
      [100.12, 21.44], [99.98, 21.74], [99.24, 22.12], [99.53, 22.95], 
      [98.90, 23.14], [98.66, 24.06], [97.60, 23.90], [97.72, 25.08], 
      [98.67, 25.92], [98.71, 26.74], [98.68, 27.51], [98.25, 27.75], 
      [97.91, 28.34], [97.33, 28.26], [96.25, 28.41], [96.59, 28.84], 
      [96.12, 29.45], [95.40, 29.03], [94.57, 29.28], [93.41, 28.64], 
      [92.50, 27.90], [91.70, 27.77], [91.26, 28.04], [90.73, 28.07], 
      [90.02, 28.30], [89.47, 28.04], [88.81, 27.30], [88.73, 28.09], 
      [88.12, 27.88], [87.03, 27.80], [86.02, 27.94], [85.25, 28.30], 
      [84.68, 27.23], [83.30, 27.36], [81.99, 27.93], [81.06, 28.42], 
      [80.09, 28.79], [79.72, 29.70], [79.30, 30.39], [79.18, 30.93], 
      [78.74, 31.52], [78.46, 32.62], [79.21, 32.99], [79.18, 33.39], 
      [78.28, 34.62], [77.84, 35.49], [76.19, 35.90], [75.90, 36.67], 
      [75.16, 37.13], [74.98, 37.42], [73.95, 37.42], [73.26, 37.49], 
      [72.63, 37.05], [72.19, 36.95], [71.84, 36.74], [71.54, 37.91], 
      [71.24, 37.95], [71.35, 38.26], [70.81, 38.49], [70.38, 38.14], 
      [70.27, 37.74], [70.12, 37.59], [69.52, 37.61], [69.20, 37.15], 
      [68.86, 37.34], [68.14, 37.02], [67.83, 37.14], [67.08, 37.36], 
      [66.52, 37.36], [66.22, 37.39], [65.47, 37.31], [65.22, 37.24], 
      [64.55, 36.31], [63.98, 36.01], [63.19, 35.86], [62.75, 35.27], 
      [62.38, 35.27], [61.88, 35.49], [61.21, 35.65], [61.12, 36.49], 
      [60.38, 36.53], [59.23, 37.41], [58.44, 37.52], [57.33, 38.03], 
      [56.62, 38.12], [56.18, 37.94], [55.51, 37.96], [54.80, 37.39], 
      [53.92, 37.20], [53.83, 36.97], [52.26, 36.70], [50.84, 36.87], 
      [50.15, 37.37], [49.11, 37.58], [48.58, 38.42], [47.69, 39.51], 
      [46.49, 39.55], [45.61, 39.90], [45.00, 39.74], [44.79, 40.04], 
      [43.93, 40.48], [43.75, 40.74], [43.58, 41.09], [42.78, 41.56], 
      [41.55, 41.54], [40.37, 41.01], [39.36, 41.14], [38.22, 40.92], 
      [36.91, 41.34], [35.17, 42.04], [33.52, 42.02], [32.35, 41.74], 
      [31.15, 41.09], [29.24, 41.22], [28.82, 40.46], [27.99, 40.97], 
      [27.29, 40.42], [26.60, 40.12], [26.30, 40.95], [26.61, 41.56], 
      [26.11, 41.33], [25.20, 41.24], [24.49, 41.58], [23.69, 41.31], 
      [22.95, 41.34], [22.60, 41.13], [22.05, 41.15], [21.67, 40.93], 
      [21.02, 40.84], [20.59, 41.09], [20.46, 41.52], [20.59, 41.86], 
      [20.52, 42.22], [20.28, 42.32], [20.05, 42.58], [19.63, 42.69], 
      [19.48, 43.35], [19.14, 43.52], [19.37, 43.99], [19.49, 44.02], 
      [19.00, 44.42], [19.39, 44.86], [19.00, 44.86], [19.01, 45.52], 
      [18.83, 45.91], [17.63, 45.95], [16.56, 46.50], [15.67, 46.21], 
      [14.63, 46.43], [13.72, 46.52], [12.48, 46.77], [11.92, 46.67], 
      [11.05, 46.75], [10.44, 46.89], [10.40, 46.86], [9.84, 47.09], 
      [9.57, 47.06], [9.56, 47.54], [9.61, 47.61], [9.48, 47.10], 
      [8.43, 47.53], [7.59, 47.58], [7.47, 47.62], [7.61, 48.20], 
      [8.10, 49.02], [6.66, 49.20], [6.19, 49.46], [6.24, 49.90], 
      [6.04, 50.13], [6.16, 50.80], [5.99, 51.85], [6.59, 51.85], 
      [6.84, 52.23], [7.09, 53.14], [6.91, 53.48], [7.10, 53.69], 
      [7.94, 53.75], [8.12, 53.53], [8.80, 54.02], [8.57, 54.40], 
      [8.53, 54.96], [9.28, 54.83], [9.92, 54.98], [9.94, 54.60], 
      [10.95, 54.36], [10.94, 54.01], [11.96, 54.20], [12.52, 54.47], 
      [13.65, 54.08], [14.12, 53.76], [14.35, 53.25], [14.07, 52.98], 
      [14.44, 52.62], [14.69, 52.09], [14.76, 52.05], [15.04, 51.10], 
      [16.36, 50.43], [16.88, 50.47], [16.94, 50.69], [17.75, 50.36], 
      [18.85, 49.51], [18.55, 49.49], [18.40, 49.32], [18.17, 49.27], 
      [18.10, 48.99], [17.91, 48.99], [17.89, 48.90], [17.55, 48.80], 
      [17.10, 48.82], [16.96, 48.60], [16.50, 48.79], [16.03, 48.76], 
      [15.26, 49.04], [14.98, 48.99], [14.85, 48.67], [14.74, 48.59], 
      [13.84, 48.77], [13.03, 47.64], [12.69, 47.67], [12.38, 47.68], 
      [11.16, 47.39], [11.05, 46.75], [10.44, 46.89], [10.40, 46.86], 
      [9.84, 47.09], [9.57, 47.06], [9.56, 47.54], [69.25, 41.18]
    ]
  },
  {
    name: "North America",
    coordinates: [
      [-163.07, 60.33], [-162.26, 60.21], [-161.53, 60.00], [-160.77, 59.36], 
      [-160.96, 58.88], [-161.52, 58.67], [-162.18, 58.67], [-162.49, 59.99], 
      [-163.82, 59.80], [-164.66, 60.27], [-165.35, 60.51], [-165.35, 61.07], 
      [-166.12, 61.50], [-165.73, 62.07], [-164.92, 62.63], [-164.56, 63.15], 
      [-163.75, 63.22], [-163.07, 63.06], [-162.26, 63.54], [-161.90, 64.20], 
      [-160.93, 64.79], [-160.82, 65.48], [-161.67, 65.68], [-162.49, 64.56], 
      [-163.72, 64.56], [-164.80, 64.45], [-166.43, 64.69], [-166.85, 65.09], 
      [-168.11, 65.67], [-166.71, 66.09], [-164.48, 66.58], [-163.65, 66.58], 
      [-163.79, 66.08], [-161.68, 66.12], [-162.49, 66.74], [-163.72, 67.12], 
      [-164.43, 67.62], [-165.39, 68.04], [-166.76, 68.36], [-166.20, 68.88], 
      [-164.43, 68.92], [-163.17, 69.37], [-162.93, 69.86], [-161.91, 70.33], 
      [-160.93, 70.45], [-159.04, 70.89], [-158.12, 70.82], [-156.58, 71.36], 
      [-155.07, 71.15], [-154.34, 70.70], [-153.90, 70.89], [-152.21, 70.83], 
      [-152.27, 70.60], [-150.74, 70.43], [-149.72, 70.53], [-147.61, 70.21], 
      [-145.69, 70.12], [-144.92, 69.99], [-143.59, 70.15], [-142.07, 69.85], 
      [-140.99, 69.71], [-140.99, 60.31], [-140.01, 60.28], [-139.04, 60.00], 
      [-138.34, 59.56], [-137.45, 58.91], [-136.48, 59.46], [-135.47, 59.79], 
      [-134.95, 59.27], [-134.27, 58.86], [-133.36, 58.41], [-132.73, 57.69], 
      [-131.70, 56.55], [-130.01, 55.91], [-129.98, 55.28], [-130.53, 54.80], 
      [-131.08, 55.18], [-131.97, 55.50], [-132.25, 56.37], [-133.54, 57.18], 
      [-134.08, 58.12], [-135.04, 58.19], [-136.63, 58.21], [-137.80, 58.50], 
      [-139.87, 59.54], [-140.83, 59.73], [-142.57, 60.08], [-143.96, 59.99], 
      [-145.93, 60.46], [-147.11, 60.88], [-148.22, 60.67], [-148.02, 59.98], 
      [-148.57, 59.91], [-149.73, 59.71], [-150.61, 59.37], [-151.72, 59.16], 
      [-151.86, 59.74], [-151.41, 60.73], [-150.35, 61.03], [-150.62, 61.28], 
      [-151.90, 60.73], [-152.58, 60.06], [-154.02, 59.35], [-153.29, 58.86], 
      [-154.23, 58.15], [-155.31, 57.73], [-156.31, 57.42], [-156.56, 56.98], 
      [-158.12, 56.46], [-158.43, 55.99], [-159.60, 55.57], [-160.29, 55.64], 
      [-161.22, 55.36], [-162.24, 55.02], [-163.07, 54.69], [-164.79, 54.40], 
      [-164.94, 54.57], [-163.85, 55.04], [-162.87, 55.35], [-161.80, 55.89], 
      [-160.56, 56.01], [-160.07, 56.42], [-158.68, 57.02], [-158.46, 57.22], 
      [-157.72, 57.57], [-157.55, 58.33], [-157.04, 58.92], [-158.19, 58.62], 
      [-158.52, 58.79], [-159.06, 58.42], [-159.71, 58.93], [-159.98, 58.57], 
      [-160.36, 59.07], [-161.36, 58.67], [-161.97, 58.67], [-162.05, 59.27], 
      [-161.87, 59.63], [-162.52, 60.00], [-163.82, 59.80], [-164.66, 60.27], 
      [-163.07, 60.33]
    ]
  },
  {
    name: "North America Main",
    coordinates: [
      [-56.13, 50.69], [-56.80, 49.81], [-56.14, 50.15], [-55.47, 49.94], 
      [-55.82, 49.59], [-54.94, 49.31], [-54.47, 49.56], [-53.48, 49.25], 
      [-53.79, 48.52], [-53.09, 48.69], [-52.96, 48.16], [-52.65, 47.54], 
      [-53.07, 46.66], [-53.52, 46.62], [-54.18, 46.81], [-53.96, 47.63], 
      [-54.24, 47.75], [-55.40, 46.88], [-55.99, 46.92], [-55.29, 47.39], 
      [-56.25, 47.63], [-57.32, 47.57], [-59.27, 47.60], [-59.42, 47.90], 
      [-58.80, 48.25], [-59.23, 48.52], [-58.39, 49.13], [-57.35, 50.71], 
      [-56.74, 51.29], [-55.87, 51.63], [-55.41, 51.59], [-55.60, 51.32], 
      [-56.13, 50.69]
    ]
  },
  {
    name: "Australia",
    coordinates: [
      [145.40, -40.79], [146.36, -41.14], [147.69, -40.81], [148.29, -40.88], 
      [148.36, -42.06], [148.02, -42.41], [147.91, -43.21], [147.56, -42.94], 
      [146.87, -43.63], [146.66, -43.58], [146.05, -43.55], [145.43, -42.69], 
      [145.30, -42.03], [144.72, -41.16], [144.74, -40.70], [145.40, -40.79]
    ]
  },
  {
    name: "Australia Main",
    coordinates: [
      [143.56, -13.76], [143.92, -14.55], [144.56, -14.17], [145.27, -14.98], 
      [145.36, -16.29], [145.80, -16.91], [145.98, -17.06], [146.39, -18.26], 
      [147.47, -19.48], [148.17, -19.96], [148.85, -20.39], [148.72, -20.63], 
      [149.29, -21.26], [149.68, -22.34], [150.08, -22.12], [150.48, -23.46], 
      [150.73, -23.46], [150.90, -23.99], [151.61, -24.08], [152.07, -24.46], 
      [152.86, -25.27], [153.14, -26.07], [153.16, -26.64], [153.09, -27.26], 
      [153.57, -28.11], [153.51, -28.99], [153.34, -29.46], [153.07, -30.35], 
      [153.09, -30.92], [152.89, -31.64], [152.45, -32.55], [151.71, -33.04], 
      [151.34, -33.82], [151.01, -34.00], [150.71, -35.17], [150.33, -36.42], 
      [150.08, -37.42], [149.95, -37.51], [149.42, -37.77], [148.30, -37.81], 
      [147.38, -38.22], [146.92, -38.61], [146.32, -39.04], [145.49, -38.59], 
      [144.88, -38.42], [145.03, -37.89], [144.49, -38.09], [143.61, -38.81], 
      [142.75, -38.54], [142.18, -38.38], [141.61, -38.31], [140.64, -38.02], 
      [139.99, -37.40], [139.80, -36.64], [139.57, -36.14], [139.08, -35.73], 
      [138.12, -35.61], [138.45, -35.12], [138.21, -34.38], [137.72, -35.08], 
      [136.83, -35.26], [137.06, -34.93], [137.39, -34.71], [137.50, -34.13], 
      [137.89, -33.64], [137.81, -32.90], [136.99, -33.75], [136.37, -34.09], 
      [135.99, -34.89], [135.21, -34.58], [135.24, -33.95], [134.61, -33.22], 
      [134.09, -32.85], [134.27, -32.62], [132.29, -32.03], [131.33, -31.50], 
      [129.54, -31.59], [128.24, -31.95], [127.10, -32.28], [126.14, -32.22], 
      [125.09, -32.29], [124.22, -32.96], [124.03, -33.48], [123.66, -33.89], 
      [122.25, -34.00], [121.30, -33.82], [120.58, -33.93], [119.89, -33.98], 
      [119.29, -34.51], [119.01, -34.46], [118.52, -34.75], [118.02, -35.06], 
      [116.63, -35.03], [115.56, -34.39], [115.03, -33.96], [115.05, -33.62], 
      [114.64, -33.22], [113.84, -32.01], [113.71, -31.53], [114.05, -30.03], 
      [114.60, -29.04], [114.72, -28.51], [114.87, -28.19], [115.05, -27.78], 
      [115.55, -27.04], [115.71, -25.92], [115.68, -25.36], [115.51, -24.54], 
      [115.55, -22.83], [115.71, -21.90], [115.68, -21.30], [115.19, -20.96], 
      [114.93, -20.62], [114.23, -19.34], [113.89, -18.39], [113.54, -17.68], 
      [113.36, -16.90], [113.59, -16.41], [113.78, -15.70], [113.73, -15.11], 
      [113.84, -14.68], [114.16, -14.39], [114.56, -13.79], [115.46, -13.30], 
      [116.71, -12.90], [117.17, -12.27], [117.99, -12.31], [118.23, -12.00], 
      [118.72, -12.17], [118.99, -12.31], [119.26, -11.95], [119.77, -11.89], 
      [120.36, -12.26], [120.87, -12.49], [121.66, -12.05], [122.24, -11.83], 
      [122.29, -11.66], [122.31, -11.15], [122.99, -11.16], [123.62, -11.61], 
      [123.86, -11.96], [124.26, -11.69], [124.38, -11.24], [124.92, -11.33], 
      [125.17, -11.51], [125.69, -11.80], [126.12, -11.30], [126.68, -11.41], 
      [127.06, -11.97], [127.80, -12.05], [128.35, -12.22], [128.99, -12.26], 
      [129.62, -12.13], [129.41, -11.88], [129.88, -11.92], [130.34, -11.86], 
      [130.62, -12.53], [131.22, -12.18], [131.74, -12.30], [132.58, -12.11], 
      [132.56, -11.60], [131.82, -11.27], [132.36, -11.13], [133.02, -11.38], 
      [133.55, -11.79], [134.39, -12.04], [134.68, -11.94], [135.30, -12.25], 
      [135.88, -11.96], [136.26, -12.05], [136.49, -11.86], [136.95, -12.35], 
      [136.69, -13.00], [135.99, -13.32], [136.08, -13.72], [135.78, -14.22], 
      [135.43, -14.72], [135.50, -14.99], [136.30, -15.55], [137.06, -15.87], 
      [137.58, -16.22], [138.30, -16.81], [138.58, -16.81], [139.11, -17.06], 
      [139.26, -17.37], [140.22, -17.71], [140.88, -17.37], [141.07, -16.83], 
      [141.27, -16.39], [141.40, -15.84], [141.70, -14.87], [141.56, -14.56], 
      [141.64, -14.27], [141.52, -13.70], [141.65, -12.94], [141.84, -12.74], 
      [141.69, -12.41], [141.93, -11.88], [142.11, -11.33], [142.14, -11.04], 
      [142.52, -10.67], [142.80, -11.16], [142.87, -11.78], [143.12, -11.91], 
      [143.16, -12.32], [143.52, -12.83], [143.60, -13.40], [143.56, -13.76]
    ]
  }
];
